<div class="colorpicker-container flex items-center gap-2">
    <div class="flex items-center gap-2 flex-1">
        <!-- Text input for manual color entry -->
        <input
               pInputText
               [ngModel]="value || ''"
               (ngModelChange)="onTextInputChange($event)"
               [disabled]="disabled"
               [placeholder]="config.placeholder || 'Enter color (e.g., #ff0000)'"
               [pTooltip]="config.placeholder || 'Enter color manually'"
               class="flex-1"
               (blur)="onTouched()">

        <!-- Color picker button -->
        <p-colorpicker
                       [ngModel]="value || '#000000'"
                       (ngModelChange)="onColorPickerChange($event)"
                       [disabled]="disabled"
                       [format]="config.format || 'hex'"
                       [inline]="config.inline || false"
                       [styleClass]="getColorPickerStyleClass()"
                       appendTo="body"
                       fixXScroll>
        </p-colorpicker>
    </div>

    <!-- Contrast color button -->
    <button
            *ngIf="config.showContrastButton && config.contrastSourceField"
            type="button"
            pButton
            icon="pi pi-palette"
            class="p-button-sm p-button-outlined"
            [disabled]="disabled || !getContrastSourceValue()"
            (click)="applyContrastColor()"
            [title]="'Get contrasting color from ' + config.contrastSourceField">
    </button>
</div>